import React, { memo } from 'react';
import RecentPaymentsTable from '@/components/payments/RecentPaymentsTable';
import PaymentList from '@/components/payments/PaymentList';
import { useOnlineStatus } from '@/utils/connectionUtils';
import { CreditCard, AlertCircle } from 'lucide-react';
import { StandardPageHeader } from '@/components/layout/StandardPageHeader';
import { AdminPageScaffold } from '@/components/core';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const RecentPaymentsSection = memo(() => {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Recent Payments</h2>
      <RecentPaymentsTable />
    </div>
  );
});
RecentPaymentsSection.displayName = 'RecentPaymentsSection';

const PaymentsDashboard = () => {
  const isOnline = useOnlineStatus();

  return (
    <>
      <StandardPageHeader
        title="Payments"
        subtitle="View and manage your hive's payments"
        icon={CreditCard}
      />
      
      <AdminPageScaffold>
        {!isOnline && (
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 flex items-center gap-2 text-amber-700 shadow-sm backdrop-blur-sm mb-6">
            <AlertCircle className="h-5 w-5" />
            <span>You are currently offline. Some payment information may be unavailable.</span>
          </div>
        )}

        <Tabs defaultValue="recent" className="w-full">
          <TabsList className="grid grid-cols-2 mb-6 max-w-md">
            <TabsTrigger value="recent">Recent Activity</TabsTrigger>
            <TabsTrigger value="all">All Payments</TabsTrigger>
          </TabsList>

          <TabsContent value="recent" className="space-y-4">
            <RecentPaymentsSection />
          </TabsContent>

          <TabsContent value="all" className="space-y-4">
            <PaymentList />
          </TabsContent>
        </Tabs>
      </AdminPageScaffold>
    </>
  );
};

export default PaymentsDashboard;
